<template>
    <div class="layout-main-container">
        <div class="layout-main">
            <FileUpload :multiple="false" customUpload @uploader="uploadBooks" :maxFileSize="5000000"
                :uploadLabel="$t('UPLOAD')" :chooseLabel="$t('CHOOSE')" :cancelLabel="$t('CANCEL')">
                <template #empty>
                    <div class="text-blue-500" style="text-align: center;">
                        <p>{{ $t('DRAG_FILE_MESSAGE') }}</p>
                        <i :class="['pi', 'pi-cloud-upload']" style="font-size: 2rem;" />
                    </div>
                </template>
            </FileUpload>
        </div>
    </div>
</template>


<script setup>
import { onErrorCaptured } from "vue"
import { handleError } from '@/helpers/ErrorHandler'
import { useToast } from "primevue/usetoast"
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import bookService from '@/service/BookService'
import FileUpload from 'primevue/fileupload';

const toast = useToast()
const i18n = useI18n()
const authStore = useAuthStore()

onErrorCaptured((err, instance, info) => {
    return handleError(authStore, toast, i18n, err, instance, info)
})

const uploadBooks = async (event) => {
    if (event.files.length > 1) {
        toast.add({ severity: 'error', summary: i18n.t('CANT_SEND_MULTIPLE_FILE'), detail: '', life: 3000 })
    } else if (!event.files[0].name.endsWith('.csv')) {
        toast.add({ severity: 'error', summary: i18n.t('UPLOADED_FILE_SHOULD_BE_CSV'), detail: '', life: 3000 })
    } else {
        const response = await bookService.uploadBooks(event.files[0], event.files[0].name)
        toast.add({ severity: 'info', summary: response.message, detail: '', life: 3000 })
    }
}

</script>

<style scoped>
:deep(.p-fileupload-file-thumbnail) {
    display: none;
}

:deep(.p-fileupload-file-remove) {
    display: none;
}
</style>